<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(1.3 2.1)">
      <path
        d="M15.222,15.417H4.111A1.111,1.111,0,0,1,3,14.306V6.528A1.111,1.111,0,0,1,4.111,5.417H6.333L7.444,3.75h4.444L13,5.417h2.222a1.111,1.111,0,0,1,1.111,1.111v7.778A1.111,1.111,0,0,1,15.222,15.417Z"
        transform="translate(-3 -3.75)"
        fill="none"
        stroke="#74788d"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
      <path
        d="M11.125,14a2.5,2.5,0,1,0-2.5-2.5,2.5,2.5,0,0,0,2.5,2.5Z"
        transform="translate(-4.458 -5.111)"
        fill="none"
        stroke="#74788d"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconCamera',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>